import { Component, OnInit } from '@angular/core';
import { LicenceService } from '../licence.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CountryService } from '../../../shared/country.service';
import { AnalyticsService } from 'src/app/shared/analytics/analytics.service';
import { Location } from '@angular/common';
import { SERVER_API_URL } from 'src/app/app.constants';

@Component({
  selector: 'app-licence-country',
  templateUrl: './licence-country.component.html',
  styleUrls: ['./licence-country.component.scss']
})
export class LicenceCountryComponent implements OnInit {
  FLAG_URL = SERVER_API_URL + 'countries/flag/';

  licenceCountryData: any;
  countryData: any;
  activeAccordion: string[] = ['CountryFacts', 'SpectrumAuthority', 'CountryOutlook'];
  graphicMode: boolean = false;

  constructor(
    private licenceService: LicenceService,
    private route: ActivatedRoute,
    public countryService: CountryService,
    public analyticsService: AnalyticsService,
    private router: Router,
    private location: Location
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  ngOnInit() {
    this.route.params.subscribe(p => {
      this.licenceService.getLicencesByCountry(p.countryCode)
        .subscribe(data => {
          this.licenceCountryData = data;
        });
      this.countryService.getCountryExternalInformations(p.countryCode)
        .subscribe(data => {
          this.countryData = data;
        });
    });
    this.route.fragment.subscribe((fragment: string) => {
      if (fragment && fragment == 'graphic') {
        this.graphicMode = true;
      }
    });
  }

  toggleActiveMode() {
    this.analyticsService.pushEvent('toggleGraphicView');
    this.graphicMode = !this.graphicMode;
    if (this.graphicMode) {
      this.location.go(this.router.url.split('#')[0] + "#graphic");
    } else {
      this.location.go(this.router.url.split('#')[0] + "#table");
    }
  }

  onClickAccordion(name: string) {
    const index = this.activeAccordion.indexOf(name);
    if (index > -1) {
      // Si l'accordéon est déjà ouvert, le fermer
      this.activeAccordion.splice(index, 1);
    } else {
      // Sinon, l'ouvrir
      this.activeAccordion.push(name);
    }
  }

  isActiveAccordion(name: string): boolean {
    return this.activeAccordion.includes(name);
  }

  isGraphicDataAvailable() {
    let fd = this.licenceCountryData.frequencyDistributions.frequencyDistributionList;
    return fd;
  }

  isGraphicMode() {
    return this.graphicMode;
  }

  isTableMode() {
    return !this.isGraphicMode();
  }

  hideSpectrumAuthority(country: any): boolean {
    return !country.authority && !country.legalBasis && !country.allocationTable;
  }

  hideAccordionArrow(country: any): boolean {
    return !country.authority && !country.legalBasis && !country.allocationTable && !country.countryOutlook;
  }

  getImageUrl(url: string) {
    return this.FLAG_URL + url;
  }

  showAsterisk(operator: any, groupedNames: any): boolean {
    return operator.value == 'Regional licences' && groupedNames;
  }

  changePopulationFormat(number: number): string {
    const decimalFormatBn = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const decimalFormatM = new Intl.NumberFormat('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    const decimalFormatM2 = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (number >= 1_000_000_000) {
      const result = number / 1_000_000_000;
      return decimalFormatBn.format(result) + 'bn';
    } else if (number >= 1_000_000) {
      const result = number / 1_000_000;
      return decimalFormatM.format(result) + 'm';
    } else if (number >= 100_000) {
      const result = number / 1_000_000;
      return decimalFormatM2.format(result) + 'm';
    } else {
      return String(number);
    }
  }
}